import { apiClient, TruckbookApiResponse } from '../axiosClient'

const CHECK_BOOKING_EXISTENCE_PATH = '/berths/booking/record-work-log/check-existence'

interface CheckExistenceParams {
  tenantId: string
  driverPhone: string
}

export interface Booking {
  bookingId: string
  status: number
  bookingNo: string
  finishedAt: string
}

type CheckExistenceResponse = TruckbookApiResponse<{
  exists: boolean
  booking: Booking | null
}>

export const checkBookingExistence = async (
  params: CheckExistenceParams
): Promise<CheckExistenceResponse> => {
  const { data } = await apiClient.get<CheckExistenceResponse>(
    CHECK_BOOKING_EXISTENCE_PATH,
    { params }
  )
  return data
}
